import * as React from 'react';
import { useSelector } from 'react-redux';

import { Utilities } from '../../components/Utilities';
import { IApplicationState } from '../../types/redux';
import { TUserState } from '../../types/user';
import { UtilityCompareContainer } from '../UtilityCompareContainer';
import { UtilityFavoritesContainer } from '../UtilityFavoritesContainer';
import { UtilityMessagesContainer } from '../UtilityMessagesContainer';
import { UtilityNotificationsContainer } from '../UtilityNotificationsContainer';
import { UtilitySavedSearchesContainer } from '../UtilitySavedSearchesContainer';

export const UtilitiesContainer: React.FC = () => {
  const user = useSelector<IApplicationState, TUserState>(state => state.user);

  return (
    <Utilities>
      <UtilityCompareContainer />
      <UtilityMessagesContainer />
      <UtilityFavoritesContainer />
      {user.isAuthenticated && <UtilitySavedSearchesContainer />}
      <UtilityNotificationsContainer />
    </Utilities>
  );
};
